import React from "react";
import PropTypes from "prop-types";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export const TruncatedTextWithTooltip = React.memo(function TruncatedTextWithTooltip({
  text,
  maxLength,
  placement = "right",
  as: As = "span",
}) {
  if (!text) return null;
  if (text.length <= maxLength) return <As>{text}</As>;

  return (
    <OverlayTrigger
      placement={placement}
      delay={{ show: 250, hide: 400 }}
      overlay={(props) => (
        <Tooltip id="truncated-tooltip" {...props}>
          {text}
        </Tooltip>
      )}
    >
      <As>{text.substring(0, maxLength) + "..."}</As>
    </OverlayTrigger>
  );
});

TruncatedTextWithTooltip.propTypes = {
  text: PropTypes.string,
  maxLength: PropTypes.number.isRequired,
  placement: PropTypes.string,
  as: PropTypes.elementType,
};
